/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import logo from "../../assets/img/esalariumlogo.png";

import Spinner from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  NavbarToggler,
  ModalHeader,
} from "reactstrap";

import './Switch.css';

import { FormGroup, Label, Form, Row, Col } from 'reactstrap';
import { store, useGlobalState } from 'state-pool';

store.setState("productivo", localStorage.getItem("modoproductivo") ?? true );

function AdminNavbar(props) {

    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    const [today, setoday] = React.useState("");

  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [modalSearch, setmodalSearch] = React.useState(false);
    const [color, setcolor] = React.useState("navbar-transparent");

    const [prod, setProd] = useGlobalState("productivo");


    React.useEffect(() => {
        var today = new Date();
        var date = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2);
        localStorage.setItem("mes", ("0" + (today.getMonth() + 1)).slice(-2));
        localStorage.setItem("anio", today.getFullYear());
        setoday(date);
        window.addEventListener("resize", updateColor);
        
        //var bool = Boolean(localStorage.getItem("modoproductivo"));
        setProd(prod);
        //console.log(bool);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setcolor("bg-white");
    } else {
      setcolor("navbar-transparent");
    }
  };
  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setcolor("navbar-transparent");
    } else {
      setcolor("bg-white");
    }
    setcollapseOpen(!collapseOpen);
  };
  // this function is to open the Search modal
  const toggleModalSearch = () => {
    setmodalSearch(!modalSearch);
  };

    const handleLogOut = () => {
        window.location = '/';
    }

    const handleProfile = () => {
        window.location = '/admin/user-profile';
    }

    const handleMonth = (e) => {
        
        var data = e.target.value;
        var dataArray = data.split("-");
        localStorage.setItem("mes", dataArray[1]);
        localStorage.setItem("anio", dataArray[0]);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleprdchecked = (e) => {

        setLoading(true);

        var id = localStorage.getItem('idEmpresa');
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        const apiUrl = './api/Auxiliar/StatusEmpresaHabilitada?iIdEmpresa='+id;
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    //dataMonedas = data.basePresentationList;
                    console.log(data);
                    setLoading(false);
                    if (data.codResponse == 0) {
                        setOpen(true);
                    } else {
                        console.log(e.target.checked);
                        setProd(e.target.checked);
                        store.setState("productivo", e.target.checked);
                        console.log(store.getState("productivo"));
                        localStorage.setItem("modoproductivo", e.target.checked);
                        setTimeout(function () {
                            window.location.reload();
                        }, 2000);
                    }
                    //setdatamonedasList(dataMonedas);
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )

    }



  return (
      <div>

          <Dialog open={loading} >
              <div style={{ textAlign: "center", margin: "15px" }}>
                  {loading && <Spinner color="secondary" />}
                  <h3 style={{ fontSize: '15px', fontFamily: 'Hammersmith One' }}>Cargando...</h3>
              </div>
          </Dialog>
          <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
          >
              <DialogTitle id="alert-dialog-title">
                  {"Estado de habilitacion"}
              </DialogTitle>
              <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                      Actualmente tu empresa no se encuentra activa en la DIAN, intenta de nuevo mas tarde.
                  </DialogContentText>
              </DialogContent>
              <DialogActions>
                  
                  <Button onClick={handleClose} autoFocus>
                      Listo
                  </Button>
              </DialogActions>
          </Dialog>
      <Navbar className={classNames("navbar-absolute", color)} expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <NavbarToggler onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
                          {/*props.brandText*/}
                          <img src={logo} style={{ width: 150, marginTop: 10 }} />
            </NavbarBrand>
          </div>
          <NavbarToggler onClick={toggleCollapse}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
                          {/*<InputGroup className="search-bar">
                <Button color="link" onClick={toggleModalSearch}>
                  <i className="tim-icons icon-zoom-split" />
                  <span className="d-lg-none d-md-block">Search</span>
                </Button>
              </InputGroup>*/}

                          <FormGroup style={{ marginTop: "-3px", marginRight: "5px" }}>
                          <input
                                  className="react-switch-checkbox"
                                  id={`react-switch-new`}
                                  type="checkbox"
                                  checked={prod}
                                  onChange={handleprdchecked}
                          />
                          <label
                              className="react-switch-label"
                              htmlFor={`react-switch-new`}
                          >
                              <span className={`react-switch-button`} />
                              </label>
                          </FormGroup>
                          <FormGroup>
                              <h3 style={{ fontSize: "13px", textAlign: "left", fontFamily: 'Hammersmith One', marginTop: "20px", marginRight: "20px" }}>Modo productivo</h3>
                          </FormGroup>
                          <FormGroup>
                              <Input type="month" defaultValue={today} name="email" id="exampleEmail" style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One', marginTop: "5px" }} onChange={handleMonth} />
                          </FormGroup>

                          <UncontrolledDropdown nav style={{marginTop: "5px"}} >
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  nav
                >
                  <div className="notification d-none d-lg-block d-xl-block" />
                  <i className="tim-icons icon-sound-wave" />
                  <p className="d-lg-none">Notificaciones</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">
                      Bienvenido a eSalarium
                    </DropdownItem>
                  </NavLink>
                  
                </DropdownMenu>
              </UncontrolledDropdown>

              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="photo">
                    <img
                      alt="..."
                                          src={require("../../assets/img/default-avatar.png").default}
                    />
                  </div>
                                  <b className="caret d-none d-lg-block d-xl-block" />
                                  <p className="d-lg-none">Cerrar Sesion</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li">
                                      <DropdownItem onClick={handleProfile} className="nav-item">Perfil</DropdownItem>
                  </NavLink>
                 
                  <DropdownItem divider tag="li" />
                  <NavLink tag="li">
                                      <DropdownItem onClick={handleLogOut} className="nav-item">Salir</DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Modal
        modalClassName="modal-search"
        isOpen={modalSearch}
        toggle={toggleModalSearch}
      >
        <ModalHeader>
          <Input placeholder="SEARCH" type="text" />
          <button
            aria-label="Close"
            className="close"
            onClick={toggleModalSearch}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </ModalHeader>
      </Modal>
    </div>
  );
}

export default AdminNavbar;
